(function (ws, $, globals) {
    'use strict';

    ws.views.quoteTableTooltipPoScrap = Backbone.View.extend({

        className: 'comp-table-tooltip',

        events:  {
            'click .updata-from-radio':'getValFromTooltip',
            'click .copy': 'copyColumnDataOnClickOfButton',
            'click .vicRemove':'getValTooltip'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg = globals.eventAgg;
            this.eventAgg.on('quoteTableTooltip', this.setProps.bind(this));
            this.timeOut = null;
            this.tooltipIsActive = 0;
            this.render();
            this.obj = null;
        },

        getValFromTooltip: function(e) {
            var val = $(e.currentTarget).val();
            if (this.options.isVrfHeader) {
                this.eventAgg.trigger('updateValue', this.options.pointerName, val);
            } else if (this.options.isOrderDetailsHeader) {
                this.eventAgg.trigger('updateOrderDetailsHeader', e, this.options.pointerName, val);
            } else {
                var fieldName = ('pricing' in this.options) ? 'getDataFromTooltip' : 'getVrfDataFromTooltip';
                this.eventAgg.trigger(fieldName, e, val, this.options.pointerName, this.options.currentRow);
            }
        },

        getValTooltip: function(e) {
            var val = $(e.currentTarget).val();
            this.eventAgg.trigger('getDataFromTooltip', e, val, 'parentEntryNumber', this.options.currentRow);
        },

        /**i
         * Set Props
         * @param {Object} options
         */
        setProps: function (options) {
            this.options = options;
            this.update();
        },

        /**i
         * Render Tooltip
         */
        render: function () {
            $('body').append(this.$el);
        },

        /**
         * Update Tooltip
         */
        update: function () {
            if (isOrderEntrySite && this.options.pointerName) {
                this.obj = {name: this.options.pointerName,
                    row: this.options.currentRow,
                    radioNotRequired: this.options.radioNotRequired,
                    parentClass: this.options.parentClass,
                    dropdownParentClass: this.options.dropdownParentClass,
                    currency: this.options.currency,
                    vc: this.options.vc,
                    model: this.options.model};
            } else if (this.options.sba) {
                this.obj = {model: this.options.model};
            }

            switch ('html' in this.options) {
                case true:
                    this.$el.html(this.options.html);
                    break;

                default:
                    if (this.options.pointerName || this.options.sba) {
                        this.$el.html(this.options.template(this.obj || {}));
                    } else {
                        this.$el.html(this.options.template(this.options.model || {}));
                    }
            }

            this.bindEvents();
            this.position();
        },

        bindEvents: function () {
            if (this.tooltipIsActive) {
                clearTimeout(this.timeOut);
                this.tooltipIsActive = 0;
            }

            $('.comp-table-tooltip').mouseleave(function() {
                $('.comp-table-tooltip').hide();
            });

            this.mouseout = function () {
                if (!this.tooltipIsActive) {
                    this.timeOut = setTimeout(() => {if ($('.comp-table-tooltip:hover').length === 0) {
                        this.$el.hide();
                    }}, 400);

                    this.tooltipIsActive = 1;
                }

                if ('onClose' in this.options) {
                    this.options.onClose();
                }

                this.options.follow.removeEventListener('mouseout', this.mouseout, false);
            }.bind(this);

            this.options.follow.addEventListener('mouseout', this.mouseout);
        },

        /**
         * Set Tooltip Position
         */
        position: function () {
            var position = this.options.follow.getBoundingClientRect();
            var leftPosition = this.options.isPricingOption ? (position.left + this.options.follow.offsetWidth + 5) - 100 : (position.left + this.options.follow.offsetWidth + 5);
            if (this.options.x !== undefined) {
                this.$el.css({ top: (this.options.y - 10) + 'px', left: (this.options.x + 50) + 'px'}).show();
            } else {
                this.$el.css({ top: position.top + (position.height / 2), left: leftPosition - 4}).show();
            }
        },

        copyColumnDataOnClickOfButton: function (e) {
            var index = $(e.currentTarget).data('position');
            var columnText = '';
            var cells = $(e.currentTarget).parents('table').find('td.' + index);

            // clear existing selections
            if (window.getSelection) { // all browsers, except IE before version 9
                window.getSelection().removeAllRanges();
            }

            if (document.createRange) {
                cells.each(function(i, cell) {
                    var rangeObj = document.createRange();
                    rangeObj.selectNodeContents(cell);
                    window.getSelection().addRange(rangeObj);
                    columnText = rangeObj.toString();
                });
            }
            else { // Internet Explorer before version 9
                cells.each(function(i, cell) {
                    var rangeObj = document.body.createTextRange();
                    rangeObj.moveToElementText(cell);
                    rangeObj.select();
                    columnText = rangeObj.toString();
                });
            }

            const el = document.createElement('textarea');
            el.value = $.trim(columnText.replace(/\s\s+/g, '\n'));

            var elem = el.value.split('\n');
            if (this.options.qty < elem.length) {
                elem.splice(this.options.qty);
                el.value = elem.join('\n');
            }

            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    });
})(westcon, jQuery, globals);
